import { render, staticRenderFns } from "./importexpress.vue?vue&type=template&id=23e37626&"
import script from "./importexpress.vue?vue&type=script&lang=js&"
export * from "./importexpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports